<template>
  <div class="my-4 flex">
    <UiInput
      id="cart-coupon-code"
      v-model="inputCode"
      wrapper-class="w-full"
      :placeholder="$t('cart.couponPlaceholder')"
    />
    <UiButton id="cart-apply-coupon" variant="secondary" :loading="isLoading" class="ml-3" @click="applyCoupon">
      {{ $t('cart.applyCoupon') }}
    </UiButton>
  </div>
</template>

<script lang="ts" setup>
import { useAppStore } from '~/stores/app/appStore';
import { useCartStore } from '~/stores/cart/cartStore';
import { CartActionType } from '~/stores/cart/types';

const cartStore = useCartStore();
const appStore = useAppStore();

const isLoading = ref<boolean>(false);
const inputCode = ref<string>();

const { locale } = useI18n();

const applyCoupon = (): void => {
  if (inputCode.value) {
    isLoading.value = true;

    cartStore
      .updateCart({
        actions: [
          {
            code: inputCode.value,
            type: CartActionType.ADD_COUPON,
          },
        ],
        country: appStore.currentCountryCode,
        locale: locale.value as Locale,
      })
      .finally(() => (isLoading.value = false));
  }
};
</script>
